module.exports = __webpack_public_path__ + "img/1527303121.d17a3e1c.jpg";